import { oneBtnPopupCreator } from 'components/popups/ConfirmPopup/helper';
import { liveQuerySubscribeLock, LIVE_QUERY_SUBSCRIBE_LOCK_KEY } from 'util/asyncLocks';
import { extractSelectedTicketIdFromState, extractSelectedTicketFromState } from 'extractFromState';
import { updateLongTransactionLoadingStatus, addNoteToTicket } from 'actions';
import subscribeToLiveQuery from '../subscribeToLiveQuery';
import { LONG_TRANSACTION_UPDATE_SUBSCRIPTION } from './longTransactionSubscriptions.gql';
import { getExpertId } from 'util/parseSelectors';

const startLongTransactionLiveQuery = (store) => {
  const handleSuccessRefund = (ticketNumber, refundAmount) => {
    let message = `Transaction successful for ticket ${ticketNumber}`;
    if (refundAmount) {
      message += `: Refunded ${refundAmount}`;
    }
    oneBtnPopupCreator({
      content: {
        main: message,
        iconPath: '/images/checkmark-green.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  const handleFailedRefund = (errorMsg) => {
    oneBtnPopupCreator({
      content: {
        main: `${errorMsg}`,
        iconPath: '/images/error-esclamation.svg',
      },
      btnConfig: 'CLOSE',
    });
  };

  liveQuerySubscribeLock.acquire(LIVE_QUERY_SUBSCRIBE_LOCK_KEY, async (lockDoneFunction) => {
    try {
      const selectedTicketId = extractSelectedTicketIdFromState(store.getState());
      const selectedTicket = extractSelectedTicketFromState(store.getState());
      const ticketNumber = selectedTicket ? selectedTicket.simplrTicketNumber : '';

      const handleOnUpdate = (longTransaction) => {
        store.dispatch(updateLongTransactionLoadingStatus(selectedTicketId, false));
        const responseType = longTransaction.responseType;

        if (responseType === 'ERROR') {
          const errorMsg = `Refund for ticket ${ticketNumber} has failed.`;

          return handleFailedRefund(errorMsg);
        }

        const refundAmount = longTransaction.refundAmount;
        const messageBody = longTransaction.messageBody;

        if (messageBody) {
          store.dispatch(addNoteToTicket(messageBody, selectedTicket));
        }

        return handleSuccessRefund(ticketNumber, refundAmount);
      };

      const expertId = getExpertId();

      if (!expertId) {
        return;
      }

      const variables = {
        filter: {
          simplrExpertId: {
            eq: expertId,
          },
        },
      };

      subscribeToLiveQuery(LONG_TRANSACTION_UPDATE_SUBSCRIPTION, variables, 'onUpdateLongTransaction', handleOnUpdate);
      store.dispatch(updateLongTransactionLoadingStatus(selectedTicketId, true));
    } finally {
      lockDoneFunction();
    }
  });
};

export { startLongTransactionLiveQuery };
